<template>
    <v-footer app class="hidden-sm-and-down header">
        Copyright &copy; 2018-2020 by BORA-DOPA All Rights Reserved. Powered by CDT-MOI-CW
        <v-spacer></v-spacer> v {{ v }}
    </v-footer>
</template>
<script>
export default {
    data: () => ({
        v: process.env.VUE_APP_VERSION,
    })
};
</script>
